<template>
  <div>
    <div class="form-group" v-if="showInput">
      <gmap-autocomplete placeholder="Start typing an address" :options="autocompleteOptions" @place_changed="setPlace">
      </gmap-autocomplete>
      <small v-if="showSubText" class="form-text text-muted">{{ subText }}</small>
      </div>
    <GmapMap
      v-if="(place || location) && showMap"
      :center="getCurrentLatLng()"
      :zoom="18"
      :options="{
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
      }"
      map-type-id="satellite"
      style="width: 100%; height: 300px"
    >
      <Gmap-Marker :position="getCurrentLatLng()" :draggable="true" @dragend="handleMarkerDrag"></Gmap-Marker>
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: 'set-location',
  components: {},
  props: {
    location: {
      type: Object,
      default: null,
      description: ''
    },
    mode: {
      type: String,
      default: 'latlon'
    },
    showInput: {
      type: Boolean,
      default: true
    },
    showMap: {
      type: Boolean,
      default: false
    },
    showSubText: {
      type: Boolean,
      default: false
    },
    subText: {
      type: String,
      default: 'Search for an address via google maps'
    }
  },
  data() {
    return {
      place: null,
      autocompleteOptions: {
        componentRestrictions: { country: 'aus' }
      }
    };
  },
  methods: {
    getCurrentLatLng() {
      if (this.place) {
        return {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng()
        };
      }
      return {
        lat: this.location.lat,
        lng: this.location.lon
      };
    },
    handleMarkerDrag: function(coords) {
      console.log(coords);
      this.$emit('onLocationSet', {
        lat: coords.latLng.lat(),
        lon: coords.latLng.lng()
      });
    },
    setPlace(place) {
      this.place = place;

      if (this.mode === 'place') {
        this.$emit('onPlaceSet', this.place);
      } else {
        this.$emit('onLocationSet', {
          lat: this.place.geometry.location.lat(),
          lon: this.place.geometry.location.lng()
        });
      }
    }
  }
};
</script>
